export const prescriptionSteps = [
  {
    number: '01',
    title: 'Visit Maisha Medical Center',
    desc: 'Receive your consultation and medical care from our healthcare professionals.',
  },
  {
    number: '02',
    title: 'Receive Your Prescription',
    desc: 'If medication is required, your healthcare professional provides your prescription.',
  },
  {
    number: '03',
    title: 'We Assist With Collection',
    desc: 'As an added-value patient service, our vehicle can be used to collect the prescribed medication from the nearest local pharmacy.',
  },
  {
    number: '04',
    title: 'Medication Collected',
    desc: 'Your prescribed medication is collected from the pharmacy, making the process easier and more convenient for you.',
  },
]
